export const getFormattedSensors = (sensors) => {
  return sensors?.map((sensor) => ({
    label: sensor.sensorId,
    value: sensor.sensorId,
  }));
};
export const getSelectedSensor = (sensors, originalId) => {
  return sensors.find((sensor) => sensor.sensorId === originalId);
};
